<template>
  <component :is="comp"></component>
</template>

<script>
import Pix from './methods/Pix.vue'
import Paypal from './methods/Paypal.vue'
import GCash from './methods/GCash.vue'
import USDT_BINANCE from './methods/USDT-BINANCE.vue'
import USDT_TRC20_BEP20 from './methods/USDT-TRC20-BEP20.vue'
import Vodafone from './methods/Vodafone.vue'
import Bank from './methods/Bank.vue'
import OVO from './methods/OVO.vue'
import DANA from './methods/DANA.vue'
import Papara from './methods/Papara.vue'
import TransferBancaria from './methods/TransferBancaria.vue'
import BankTransfer from './methods/BankTransfer.vue'

import TransfiyaBancaria from './methods/TransfiyaBancaria.vue'
import Orange from './methods/Orange.vue'
import USDT from './methods/USDT.vue'
import USDT_TRC20 from './methods/USDT-TRC20.vue'

// prettier-ignore
const compMap = {
  PIX: Pix,
  Paypal: Paypal,
  GCash: GCash,
  'USDT(BINANCE)': USDT_BINANCE,
  'USDT(TRC20/BEP20)': USDT_TRC20_BEP20,
  Vodafone: Vodafone,
  Bank: Bank,
  OVO: OVO,
  DANA: DANA,
  Papara: Papara,
  'Transfer bancaria': TransferBancaria,
  'Bank Transfer': BankTransfer,
  // 废弃
  'Transfiya bancaria': TransfiyaBancaria,
  Orange: Orange,
  USDT: USDT,
  'USDT(TRC20)': USDT_TRC20
}
export default {
  data() {
    return {
      comp: null,
    }
  },
  created() {
    const method = this.$route.query.withdrawalMethod
    if (method && compMap[method]) {
      this.comp = compMap[method]
    }

    // mock
    // this.comp = USDT_TRC20
  },
}
</script>
